// @ts-nocheck
import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../ui/card";
import { Button } from "../../ui/button";
import { Loader2, Play, Square, RefreshCw, CheckCircle2, Clock, Activity } from "lucide-react";
import { useToast } from "../../../contexts/ToastContext";
import { api } from "../../../services/api";

export function TradingCollectorControl() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState<string | null>(null);
  const [status, setStatus] = useState<any>(null);

  const loadStatus = async () => {
    try {
      const result = await api.getTradingCollectorStatus();
      if (result.success) {
        setStatus(result.data);
      }
    } catch (err: any) {
      console.error("Failed to load trading collector status:", err);
    }
  };

  useEffect(() => {
    loadStatus();
    const interval = setInterval(loadStatus, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleAction = async (action: 'start' | 'stop' | 'restart') => {
    setActionLoading(action);
    try {
      let result;
      if (action === 'start') result = await api.startTradingCollector();
      else if (action === 'stop') result = await api.stopTradingCollector();
      else result = await api.restartTradingCollector();

      if (result.success) {
        showToast({
          type: 'success',
          title: 'Berhasil',
          message: `Trading Data Collector berhasil ${action === 'start' ? 'dijalankan' : action === 'stop' ? 'dihentikan' : 'di-restart'}`
        });
        loadStatus();
      } else {
        showToast({ type: 'error', title: 'Gagal', message: result.error || `Gagal ${action} trading collector` });
      }
    } catch (err: any) {
      showToast({ type: 'error', title: 'Error', message: err.message });
    } finally {
      setActionLoading(null);
    }
  };

  const isActive = status?.active;

  return (
    <Card className="mb-6 overflow-hidden border-t-4 border-t-blue-600 shadow-lg bg-[#0f172a] text-slate-200">
      <CardHeader className="bg-slate-900/50 pb-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Activity className="w-6 h-6 text-blue-400" />
            </div>
            <div>
              <CardTitle className="text-xl text-white">Trading Data Collector</CardTitle>
              <CardDescription className="text-slate-400">Orderbook & Running Trade Real-time Collector</CardDescription>
            </div>
          </div>
          <div className={`px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1.5 ${isActive ? 'bg-green-500/20 text-green-400 border border-green-500/30' : 'bg-slate-500/20 text-slate-400 border border-slate-500/30'}`}>
            {isActive ? <CheckCircle2 className="w-3.5 h-3.5" /> : <Clock className="w-3.5 h-3.5" />}
            {isActive ? 'ACTIVE' : 'INACTIVE'}
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Button 
            onClick={() => handleAction('start')} 
            disabled={isActive || actionLoading !== null}
            className="h-12 bg-green-600 hover:bg-green-700 text-white border-none rounded-xl transition-all active:scale-95 disabled:opacity-50"
          >
            {actionLoading === 'start' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Play className="w-4 h-4 mr-2" />}
            Start Collector
          </Button>
          <Button 
            onClick={() => handleAction('stop')} 
            disabled={!isActive || actionLoading !== null}
            variant="destructive"
            className="h-12 bg-red-600 hover:bg-red-700 text-white border-none rounded-xl transition-all active:scale-95 disabled:opacity-50"
          >
            {actionLoading === 'stop' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Square className="w-4 h-4 mr-2" />}
            Stop Collector
          </Button>
          <Button 
            onClick={() => handleAction('restart')} 
            disabled={actionLoading !== null}
            variant="outline"
            className="h-12 border-blue-500/30 text-blue-400 hover:bg-blue-500/10 hover:text-blue-300 rounded-xl transition-all active:scale-95"
          >
            {actionLoading === 'restart' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
            Restart Services
          </Button>
        </div>

        <div className="mt-6 p-4 bg-blue-500/5 border border-blue-500/20 rounded-xl">
          <div className="flex gap-3 text-xs text-blue-200/70 leading-relaxed">
            <div className="flex flex-col gap-1">
              <span className="font-semibold text-blue-300">Operational Info:</span>
              <p>This service collects real-time orderbook and running trade data for all emitens listed in <code>emiten_list.csv</code>. Use <strong>Restart Services</strong> if you encounter "socket hang up" errors or token expiration issues.</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
